import React from "react";

import { LoadingTextStyled } from "./loadingText.styles";

const LoadingText = ({ ...otherProps }) => {
  return (
    <LoadingTextStyled
      {...otherProps}
      //   id="man-loader2"
      //   style={{ position: "absolute", top: "45%", right: "40%" }}
    >
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </LoadingTextStyled>
  );
};

export default LoadingText;
